import { useLayoutEffect, useRef } from 'react'
import styles from './AIResponseLog.module.scss'

/**
 * Renders monospace payload with simple highlighting for scalar values after ": ".
 * @param {{ text: string }} props
 */
export default function PayloadBoxBody({ text }) {
  const boxRef = useRef(null)
  const lines = text.split('\n')

  useLayoutEffect(() => {
    const box = boxRef.current
    if (!box) return
    box.scrollTop = box.scrollHeight
  }, [text])

  return (
    <div ref={boxRef} className={styles.payloadBox}>
      <pre className={styles.payloadPre}>
        {lines.map((line, i) => (
          <span key={i}>
            {highlightLine(line)}
            {i < lines.length - 1 ? '\n' : ''}
          </span>
        ))}
      </pre>
    </div>
  )
}

/**
 * @param {string} line
 */
function highlightLine(line) {
  const match = /^(\s*[\w.-]+:\s*)(.+)$/.exec(line)
  if (!match) return line
  return (
    <>
      {match[1]}
      <span className={styles.payloadValue}>{match[2]}</span>
    </>
  )
}
